let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Sbfy")).then(() => parcelRequire('3mMpB'));